module.exports = __webpack_public_path__ + "img/img-13.4c3cd4cf.png";